export default __webpack_public_path__ + "static/media/AddIcon.5657a6b2.svg";